import { PhoneForwardIcon } from './PhoneForwardIcon';

/**
 * author: Google
 * id 5EF77B27-31D7-47F8-8D72-8BC040CD154E
 * name phone-forward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-forward.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneForwardIcon = PhoneForwardIcon;
export default TelephoneForwardIcon